import React from 'react'

import Text, { TextStyles } from '@cinch/oxd-components/text/src/text.component'

import * as styles from './omni-value.module.css'

const OmniValue = ({ value, label }: { value: string; label: string }) => {
  return (
    <div className={styles.container}>
      <div className={styles.text}>
        <Text type={TextStyles.bullet} className={styles.label} children={label} />
        <Text type={TextStyles.cardFocalText} className={styles.value} children={value} />
      </div>
      <div className={styles.omni} />
    </div>
  )
}

export default OmniValue
